import * as React from "react";
import { useState } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { Button, Input } from "components/bootstrap";
import { FormikFormGroup, Select } from "components/common";
const AUTH_OPTIONS = [
  { value: "automatic", labelKey: "azure_credentials.auth_automatic" },
  { value: "account_key", labelKey: "azure_credentials.auth_account_key" }
];
export const validateAzureCredentialsForm = (values) => {
  var _a;
  const errors = {};
  if (!values.auth_mode) {
    errors.auth_mode = i18n.t("azure_credentials.required", { ns: "enterprise_data_tiering" });
  }
  if (!((_a = values.account_name) == null ? void 0 : _a.trim())) {
    errors.account_name = i18n.t("azure_credentials.required", { ns: "enterprise_data_tiering" });
  }
  if (values.auth_mode === "account_key" && (!values.account_key || "delete_value" in values.account_key)) {
    errors.account_key = i18n.t("azure_credentials.account_key_required", { ns: "enterprise_data_tiering" });
  }
  return errors;
};
const AzureCredentialsFormFields = ({ keyIsSet }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { values, errors, setFieldValue } = useFormikContext();
  const [showResetButton, setShowResetButton] = useState(keyIsSet);
  const keyError = errors.account_key;
  const authOptions = AUTH_OPTIONS.map(({ value, labelKey }) => ({ value, label: t(labelKey) }));
  const setKey = (key) => setFieldValue("account_key", key);
  const toggleKeyReset = () => {
    if (showResetButton) {
      setKey({ delete_value: true });
      setShowResetButton(false);
    } else {
      setKey({ keep_value: true });
      setShowResetButton(true);
    }
  };
  const handleAuthModeChange = (authMode) => {
    if (authMode === values.auth_mode) {
      return;
    }
    if (authMode === "automatic") {
      setKey(void 0);
      setShowResetButton(false);
    } else {
      setKey(keyIsSet ? { keep_value: true } : void 0);
      setShowResetButton(keyIsSet);
    }
    setFieldValue("auth_mode", authMode);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "account_name",
      type: "text",
      label: t("azure_credentials.account_name"),
      placeholder: t("azure_credentials.account_name_placeholder"),
      help: t("azure_credentials.account_name_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "endpoint_uri",
      type: "text",
      label: t("azure_credentials.endpoint_uri"),
      help: t("azure_credentials.endpoint_uri_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-auth-mode",
      label: t("azure_credentials.auth_type"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "credentialsAuthMode",
        name: "auth_mode",
        placeholder: t("azure_credentials.auth_type_placeholder"),
        "aria-label": t("azure_credentials.auth_type_aria"),
        options: authOptions,
        onChange: handleAuthModeChange,
        clearable: false,
        value: values.auth_mode
      }
    )
  ), values.auth_mode === "account_key" && (showResetButton ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-account-key-reset",
      label: t("azure_credentials.account_key"),
      error: keyError,
      bsStyle: keyError ? "error" : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleKeyReset }, t("azure_form.reset_key"))
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-account-key",
      type: "password",
      label: t("azure_credentials.account_key"),
      error: keyError,
      bsStyle: keyError ? "error" : void 0,
      onChange: ({ target: { value } }) => setKey(value === "" ? { delete_value: true } : { set_value: value }),
      buttonAfter: keyIsSet ? /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleKeyReset }, t("azure_form.undo_reset")) : void 0,
      placeholder: "****************",
      help: t("azure_credentials.account_key_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  )));
};
export default AzureCredentialsFormFields;
